module.exports = __webpack_public_path__ + "img/logo2.8f5480d8.png";